import { getCommentSchema } from "./commentSchema";
import { api } from "../../../../common/utils/api";
import { executeRecaptcha } from "../../../../common/utils/recaptcha";

export const initCommentForm = () => {
  const container = document.getElementById("comment-form-wrapper");
  const form = container?.querySelector<HTMLFormElement>(".comment-form");
  const translations =
    (window as any).commonVariables?.translations?.comments || {};

  if (!form || !container) return;

  const fieldset = form.querySelector("fieldset");
  const submitBtn = form.querySelector<HTMLButtonElement>(
    ".comment-form__submit",
  );
  const errorAlert = form.querySelector<HTMLElement>(
    ".comment-form__alert--error",
  );
  const originalBtnText = submitBtn?.innerText || "";

  const setFieldError = (fieldName: string, message: string) => {
    const input = form.querySelector(`[name="${fieldName}"]`);
    const errorDiv = input
      ?.closest(".cf-field")
      ?.querySelector(".cf-field__error");
    if (input && errorDiv) {
      input.classList.add("has-error");
      errorDiv.textContent = message;
    }
  };

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Temizle
    form
      .querySelectorAll(".cf-field__input")
      .forEach((el) => el.classList.remove("has-error"));
    form
      .querySelectorAll(".cf-field__error")
      .forEach((el) => (el.textContent = ""));
    if (errorAlert) {
      errorAlert.style.display = "none";
      errorAlert.innerHTML = "";
    }

    const formData = new FormData(form);
    const rawData = Object.fromEntries(formData.entries());

    const result = getCommentSchema().safeParse(rawData);

    if (!result.success) {
      Object.entries(result.error.flatten().fieldErrors).forEach(
        ([field, msgs]) => {
          if (msgs) setFieldError(field, msgs[0]);
        },
      );
      return;
    }

    if (fieldset) fieldset.disabled = true;
    if (submitBtn)
      submitBtn.innerText = translations.sending || "Gönderiliyor...";

    try {
      const recaptchaToken = await executeRecaptcha("comment_form");
      const payload = { ...result.data, recaptcha_token: recaptchaToken };

      await api.post("/forms/comment", payload);

      // Başarılı durumu: Formu gizle ve mesaj göster
      container.innerHTML = `
        <div style="padding: 2rem; background-color: var(--color-background-soft); border-radius: var(--radius-md); text-align: center; border: 1px solid var(--color-success);">
          <h4 style="color: var(--color-success); margin-bottom: 0.5rem;">Teşekkürler</h4>
          <p style="color: var(--color-text-secondary); margin: 0;">${translations.successMessage}</p>
        </div>
      `;
    } catch (err: any) {
      if (fieldset) fieldset.disabled = false;
      if (submitBtn) submitBtn.innerText = originalBtnText;

      if (errorAlert) {
        errorAlert.style.display = "flex";
        errorAlert.innerHTML = `<span>${err.message || "Hata oluştu."}</span>`;
      }
    }
  });
};
